import { render, staticRenderFns } from "./HighTechProducts.vue?vue&type=template&id=5b178d07&scoped=true"
import script from "./HighTechProducts.vue?vue&type=script&lang=js"
export * from "./HighTechProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b178d07",
  null
  
)

export default component.exports